(() => {
  const mobileQuery = window.matchMedia('(max-width: 640px)');

  function updateFaqLink(footer) {
    if (!footer) return;

    footer.querySelectorAll('a[href]').forEach((link) => {
      try {
        const url = new URL(link.href, window.location.origin);
        if (url.pathname === '/pages/faqs') {
          link.setAttribute('href', '/pages/faq');
          link.textContent = 'FAQ';
        }
      } catch (error) {
        // Ignore non-standard URLs.
      }
    });
  }

  function setupLocalizationSelect(footer) {
    if (!footer) return;

    footer.querySelectorAll('.littos-footer__country-select').forEach((select) => {
      if (select.dataset.littosLocalizationReady === 'true') return;

      select.dataset.littosLocalizationReady = 'true';
      ['pointerdown', 'mousedown', 'click', 'touchstart'].forEach((eventName) => {
        select.addEventListener(eventName, (event) => {
          event.stopPropagation();
        });
      });
    });
  }

  function setupFooter(footer) {
    if (!footer) return;

    updateFaqLink(footer);
    setupLocalizationSelect(footer);

    if (footer.dataset.littosMobileFooterReady === 'true') return;

    const items = Array.from(footer.querySelectorAll('.littos-footer__menu-details'));
    if (!items.length) return;

    footer.dataset.littosMobileFooterReady = 'true';
    let lastMobileState = null;

    const syncViewportState = () => {
      const isMobile = mobileQuery.matches;
      if (lastMobileState === isMobile) return;

      items.forEach((item) => {
        if (isMobile) item.removeAttribute('open');
        else item.setAttribute('open', '');
      });

      lastMobileState = isMobile;
    };

    items.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!mobileQuery.matches || !item.open) return;
        items.forEach((other) => {
          if (other !== item) other.removeAttribute('open');
        });
      });
    });

    syncViewportState();

    const onViewportChange = () => syncViewportState();
    if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', onViewportChange);
    else if (mobileQuery.addListener) mobileQuery.addListener(onViewportChange);
  }

  function setupAllFooters(root = document) {
    root.querySelectorAll('.littos-footer').forEach(setupFooter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setupAllFooters());
  } else {
    setupAllFooters();
  }

  document.addEventListener('shopify:section:load', (event) => {
    setupAllFooters(event.target || document);
  });
})();
